import * as React from 'react';

import { RoundButton, MenuItem, MovableContextMenu } from '../..';
import { ConstantFunctions, useOpenMenuWithPosition } from '../../../utils';
import { MenuItem as MenuItemType } from './interface';

import { Styled } from './styled';

const BUTTON_SIZE = 30;

interface Props {
  menuItems: MenuItemType[];
  icon: any;
}

export const PaymentMethodMenu: React.FC<Props> = (props) => {
  const { menuItems, icon } = props;
  const {
    isOpen,
    position,
    onOpen,
    onClose,
  } = useOpenMenuWithPosition();

  if (!menuItems || !menuItems.length) {
    return null;
  }

  return (
    <Styled.PaymentMethodMenuContainer
      marginTop={0}
      onClick={ConstantFunctions.stopEvent}
      onMouseDown={ConstantFunctions.stopEvent}
    >
      <RoundButton
        Icon={icon}
        diameter={BUTTON_SIZE}
        onClick={onOpen}
        iconColor='white'
      />
      {isOpen &&
        <MovableContextMenu
          x={position.x}
          y={position.y}
          onClose={onClose}
        >
          {menuItems.map(item =>
            (<MenuItem
              // eslint-disable-next-line react/jsx-no-bind
              Icon={() => null}
              text={item.text}
              key={item.text}
              size='m'
              // eslint-disable-next-line react/jsx-no-bind
              onClick={() => {
                onClose();
                item.onClick();
              }}
            />),
          )}
        </MovableContextMenu>}
    </Styled.PaymentMethodMenuContainer>
  );
};
